import { render } from "./CardPost.vue?vue&type=template&id=1c6f81ec&scoped=true"
import script from "./CardPost.vue?vue&type=script&lang=js"
export * from "./CardPost.vue?vue&type=script&lang=js"

import "./CardPost.vue?vue&type=style&index=0&id=1c6f81ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6f81ec"]])

export default __exports__